<template>
  <div class="st-info-icon">
    <em
      v-tooltip="{
        content: tooltipText,
        onShow: () => !disableTooltip,
        placement: 'top',
      }"
      class="custom-icons"
      :style="{
        ...getCustomIconStyle(iconPath(icon)),
        backgroundColor: iconColor,
      }"
    />
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'StInfoIcon',
  mixins: [customIconsMixin],
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: true,
    },
    disableTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltipText: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
